// AbracadaTchatFAB - Bouton flottant pour accéder à la messagerie
// Position: fixed, bottom 76px, right 16px
// Style: rond 52px, fond #E8650A, icône 💬 blanc, label "Tchat" 9px
// ⚠️ Ce composant n'ouvre que la page messages existante - NE PAS MODIFIER la logique de messagerie

import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';

import { API_URL } from '../../config/api';

export default function AbracadaTchatFAB() {
  const navigate = useNavigate();
  const location = useLocation();
  const [unreadCount, setUnreadCount] = useState(0);
  
  // Vérifier si on est sur la page messages (ne pas afficher le FAB)
  const isMessagesPage = location.pathname.startsWith('/messages');
  
  // Récupérer le nombre de messages non lus
  useEffect(() => {
    const fetchUnreadCount = async () => {
      const token = localStorage.getItem('ecosystem_token');
      if (!token) return;
      
      try {
        const response = await fetch(`${API_URL}/api/messages/unread/count`, {
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });
        
        if (response.ok) {
          const data = await response.json();
          setUnreadCount(data.count || 0);
        }
      } catch (error) {
        // Silently fail - unread count is not critical
      }
    };
    
    fetchUnreadCount();
    
    // Polling toutes les 30 secondes
    const interval = setInterval(fetchUnreadCount, 30000);
    return () => clearInterval(interval);
  }, []);

  // Ne pas afficher sur la page messages
  // Masqué complètement - remplacé par FloatingAIAssistant sur mobile
  if (isMessagesPage) return null;
  
  // FAB Tchat désactivé sur mobile - l'Assistant IA le remplace
  return null;

  const handleClick = () => {
    navigate('/messages');
  };

  return (
    <motion.button
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ type: 'spring', stiffness: 260, damping: 20, delay: 0.3 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
      onClick={handleClick}
      className="fixed z-[8999] md:hidden flex flex-col items-center gap-0.5"
      style={{
        bottom: '76px',
        right: '16px',
      }}
      data-testid="abracadatchat-fab"
    >
      {/* Bouton rond */}
      <div 
        className="relative flex items-center justify-center"
        style={{
          width: '52px',
          height: '52px',
          borderRadius: '50%',
          background: '#E8650A',
          boxShadow: '0 4px 14px rgba(232, 101, 10, 0.4), 0 2px 6px rgba(0,0,0,0.15)',
        }}
      >
        <MessageCircle size={24} className="text-white" strokeWidth={2} />
        
        {/* Badge messages non lus */}
        {unreadCount > 0 && (
          <motion.span
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            className="absolute -top-1 -right-1 flex items-center justify-center"
            style={{
              width: unreadCount > 9 ? '22px' : '18px',
              height: '18px',
              borderRadius: '9px',
              background: '#EF4444',
              border: '2px solid white',
              fontSize: '10px',
              fontWeight: 700,
              color: 'white',
            }}
          >
            {unreadCount > 99 ? '99+' : unreadCount}
          </motion.span>
        )}
      </div>
      
      {/* Label */}
      <span 
        style={{
          fontSize: '9px',
          fontWeight: 600,
          color: 'rgba(255,255,255,0.7)',
          fontFamily: "'DM Sans', sans-serif",
        }}
      >
        Tchat
      </span>
    </motion.button>
  );
}
